import { useParams } from 'react-router-dom';
import { WavelightsContainer } from './styles';
import { useAppDispatch, useAppSelector } from '../../../hooks';
import { HeartBeatsData, WavelightsState } from '../types';
import { useEffect } from 'react';
import { getTechnique } from '../reducer';
import Loading from '../../../components/Loading';
import { Technique, WaveTechniques } from '../../../types';
import { Card } from '@blueprintjs/core';
import ReactJson from 'react-json-view';
import HeartBeats from '../components/HeartBeats';

const WavelightsWavesTechniquesItem = () => {
  const { tid } = useParams();
  const dispatch = useAppDispatch();
  const { technique }: WavelightsState = useAppSelector(
    (state) => state.wavelight,
  );

  useEffect(() => {
    dispatch(getTechnique({ id: tid as string }));
  }, [dispatch, tid]);

  const getWidget = (item: Technique) => {
    switch (item.technique) {
      case WaveTechniques.HEART_BEATS:
        return <HeartBeats data={item.data as HeartBeatsData} />;
    }
    return null;
  };

  if (!technique) {
    return <Loading />;
  }

  return (
    <WavelightsContainer>
      <Card>
        <div>
          <strong>Técnica</strong>: {technique.technique}
        </div>
        <div>
          <strong>Versão</strong>: {technique.version}
        </div>
        <div>
          <strong>Duração</strong>: {technique.process_time_taken}
        </div>
        <Card
          style={{
            margin: '10px',
          }}
        >
          <ReactJson src={technique.configuration} />
        </Card>
      </Card>
      <Card>{getWidget(technique)}</Card>
    </WavelightsContainer>
  );
};

export default WavelightsWavesTechniquesItem;
